import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import TimeEntry from './pages/TimeEntry';
import Dashboard from './pages/Dashboard';
import Archive from './pages/Archive';
import Settings from './pages/Settings';
import './App.css';

export default function App() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <Router>
      <div className="App">
        <header className="header">
          <div className="headerContent">
            <h1 className="logo">TimeTracker</h1>
            <nav className={`nav ${menuOpen ? 'open' : ''}`}>
              <Link to="/" onClick={() => setMenuOpen(false)}>
                New Entry
              </Link>
              <Link to="/dashboard" onClick={() => setMenuOpen(false)}>
                Dashboard
              </Link>
              <Link to="/archive" onClick={() => setMenuOpen(false)}>
                Archive
              </Link>
              <Link to="/settings" onClick={() => setMenuOpen(false)}>
                Settings
              </Link>
            </nav>
            <button
              className="hamburger"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle menu"
            >
              ☰
            </button>
          </div>
        </header>

        <main className="main">
          <Routes>
            <Route path="/" element={<TimeEntry />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/archive" element={<Archive />} />
            <Route path="/settings" element={<Settings />} />
          </Routes>
        </main>

        <footer className="footer">
          <p>&copy; 2026 TimeTracker. All rights reserved.</p>
        </footer>
      </div>
    </Router>
  );
}
